/* eslint-disable no-unused-vars */

import React, { useState, useRef, useEffect } from 'react';

import style from './style.module.scss';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Icon from '@components/icon-component';

const PullToRefresh = ({ noPullToDownRefresh, children }) => {
  // const [pulling, setPulling] = useState(false);
  // const [spinnerHeight, setSpinnerHeight] = useState(0);
  // const [validPull, setValidPull] = useState(false); // Track if the pull is valid
  // const touchStartY = useRef(0);
  // const touchEndY = useRef(0);
  // const threshold = 100; // Height to trigger refresh
  // const touchMoveDistance = useRef(0); // Track the distance moved
  // const { search } = useLocation();
  // const navigate = useNavigate();
  // const [searchParams] = useSearchParams();
  // const refetchSitesLocation = searchParams.get('RefetchSitesLocation');

  // const handleTouchStart = (e) => {
  //   console.log('handleTouchStart');
  //   const virtualListScrollPosition = document?.querySelector('.cstmScrollerRef')?.scrollTop;
  //   if (virtualListScrollPosition === 0) {
  //     touchStartY.current = e.touches[0].clientY;
  //     touchMoveDistance.current = 0;
  //     setValidPull(true);
  //   }
  // };

  // const handleTouchMove = (e) => {
  //   console.log('handleTouchMove');
  //   const virtualListScrollPosition = document?.querySelector('.cstmScrollerRef')?.scrollTop;
  //   if (virtualListScrollPosition === 0) {
  //     const touchY = e.touches[0].clientY;
  //     const distance = touchY - touchStartY.current;

  //     if (distance > 0) {
  //       touchMoveDistance.current = distance;
  //       setPulling(true);
  //       setSpinnerHeight(distance); // Remove the Math.min to allow pulling beyond threshold
  //     }
  //   }
  // };

  // const handleTouchEnd = () => {
  //   const virtualListScrollPosition = document?.querySelector('.cstmScrollerRef')?.scrollTop;
  //   if (virtualListScrollPosition === 0) {
  //     if (pulling) {
  //       touchEndY.current = touchMoveDistance.current;

  //       // Check if the pull distance meets minimum threshold
  //       if (touchEndY.current < threshold) {
  //         setValidPull(false);
  //         setPulling(false);
  //         setSpinnerHeight(0);
  //       } else {
  //         // Animate back to threshold height
  //         setSpinnerHeight(threshold);
  //         setValidPull(true);
  //         setTimeout(() => {
  //           onRefresh();
  //         }, 100);
  //       }
  //     }
  //   }
  // };

  // const onRefresh = async () => {
  //   console.log('refreshData');

  //   const params = new URLSearchParams(search);
  //   if (!params.has('RefetchSitesLocation')) {
  //     if (params.toString()) {
  //       params.set('RefetchSitesLocation', 'true');
  //     } else {
  //       params.append('RefetchSitesLocation', 'true');
  //     }

  //     navigate(`${location.pathname}?${params.toString()}`, { replace: true });

  //     setTimeout(() => {
  //       if (params.has('RefetchSitesLocation')) {
  //         params.delete('RefetchSitesLocation');

  //         const newSearch = params.toString();
  //         const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;

  //         navigate(newUrl, { replace: true });

  //         setPulling(false);
  //         setSpinnerHeight(0);
  //         setValidPull(true); // Reset valid pull for the next interaction
  //       }
  //     }, 4000);
  //   }
  // };

  return <>{children}</>;
  // !noPullToDownRefresh ? (
  //   <div
  //     className={style.pullToRefreshContainer}
  //     onTouchStart={handleTouchStart}
  //     onTouchMove={handleTouchMove}
  //     onTouchEnd={handleTouchEnd}
  //     id="pullToRefreshContainer"
  //   >
  //     <div
  //       className={style.pullToRefreshSpinner}
  //       style={{
  //         height: `${spinnerHeight}px`,
  //         opacity: spinnerHeight / threshold
  //       }}
  //     >
  //       {refetchSitesLocation ? (
  //         <Icon name={'pull-to-down-refresh-icon'} className={style.rotatingImg} />
  //       ) : pulling ? (
  //         <Icon name={'pull-to-down-icon'} />
  //       ) : (
  //         <></>
  //       )}
  //     </div>

  //     <div className={style.content}>{children}</div>
  //   </div>
  // ) : (

  // );
};

export default PullToRefresh;
